import "core-js/modules/es.promise.js";
import { uniCall } from '../../utils';
/**
 * 设置导航栏关闭图标显隐
 */

export function setCloseButtonVisibility(visibility) {
  return new Promise(function (resolve) {
    uniCall({
      api: 'setCloseButtonVisibility',
      param: JSON.stringify({
        visibility: visibility
      })
    });
    resolve();
  });
}